import {useState} from "react";
import {App, Button, Checkbox, Form, Input, Typography} from "antd";
import {UserOutlined, LockOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";

import {useAuth} from "@modules/auth/AuthContext.jsx";
import {ROUTE_MAP} from "@modules/auth/menuCatalog.js";
import brand from "@/assets/brand.webp";
import "./LoginPage.css";

const {Title, Text} = Typography;

export default function LoginPage()
{
	const {login} = useAuth();
	const {message} = App.useApp();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const onFinish = async ({username, password, remember}) =>
	{
		setLoading(true);
		try
		{
			const u = await login(username, password, remember);
			navigate(ROUTE_MAP[u.landingMenuItem] || "/", {replace: true});
		}
		catch (e)
		{
			// Server giu' (es. durante un deploy): non sono le credenziali a essere sbagliate.
			if (!e?.response || e.response.status >= 500)
				message.error("Server momentaneamente non disponibile, riprova tra qualche secondo");
			else
				message.error("Credenziali non valide");
		}
		finally
		{
			setLoading(false);
		}
	};

	return (
		<div className="lv3">
			<div className="lv3-container">
				<div className="lv3-accent">
					<img src={brand} alt="VolantinoPiù" className="lv3-logo" />
					<span className="lv3-product-name">VolantinoPiù</span>
					<div className="lv3-accent-stripe" />
				</div>
				<div className="lv3-form-zone">
					<Title level={3} className="lv3-title">Accedi</Title>
					<Text className="lv3-sub">Console Operativa VolantinoPiù</Text>
					<Form layout="vertical" onFinish={onFinish} requiredMark={false} style={{marginTop: 24}}>
						<Form.Item name="username" rules={[{required: true, message: "Inserisci l'username"}]}>
							<Input size="large" prefix={<UserOutlined/>} placeholder="Username" autoFocus autoComplete="username"/>
						</Form.Item>
						<Form.Item name="password" rules={[{required: true, message: "Inserisci la password"}]}>
							<Input.Password size="large" prefix={<LockOutlined/>} placeholder="Password" autoComplete="current-password"/>
						</Form.Item>
						<Form.Item name="remember" valuePropName="checked" initialValue={true} style={{marginBottom: 12}}>
							<Checkbox>Ricordami (mantieni l'accesso per 30 giorni)</Checkbox>
						</Form.Item>
						<Button type="primary" size="large" htmlType="submit" block loading={loading}>
							Entra
						</Button>
					</Form>
				</div>
			</div>
		</div>
	);
}
